module.exports = __webpack_public_path__ + "img/img-50.db1bc26f.png";